import { createSlice, PayloadAction } from '@reduxjs/toolkit'

export interface AgencyDetailsState {
  agencyDetails: {
    companyName: string
    trading: string
    registrationNumber: string
    vatNumber: string
    ffcNumber: string
  }
  agencyAddress: {
    addressLine1: string
    addressLine2: string
    city: string
    province: string
    postalCode: string
    country: string
  }
  agencyBankDetails: {
    bank: string
    accountNumber: string
    accountType: string
    branchCode: string
    accountName: string
  }
  agencyContactDetails: {
    emailAddress: string
    telephoneNumber: string
  }
}

export const initialState: AgencyDetailsState = {
  agencyDetails: {
    companyName: '',
    trading: '',
    registrationNumber: '',
    vatNumber: '',
    ffcNumber: '',
  },
  agencyAddress: {
    addressLine1: '',
    addressLine2: '',
    city: '',
    province: '',
    postalCode: '',
    country: '',
  },
  agencyBankDetails: {
    bank: '',
    accountNumber: '',
    accountType: '',
    branchCode: '',
    accountName: '',
  },
  agencyContactDetails: {
    emailAddress: '',
    telephoneNumber: '',
  },
}

const agencyDetailsSlice = createSlice({
  name: 'chatbot/dialogs/agencyDetails',
  initialState,
  reducers: {
    detailsSubmitted: (state, action: PayloadAction<Partial<AgencyDetailsState>>) => {
      Object.assign(state, action.payload)
    },
  },
})

export const { reducer } = agencyDetailsSlice
export const agencyDetailsEvents = agencyDetailsSlice.actions
